import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { parseRmaOverviewDTO, RmaOverviewDTO } from 'components/ordering/rma/api/dtos/rma-overview-dto.js'

export class GetRmaOverview extends RmaRequest<RmaOverviewDTO, never> {
  path: string

  constructor(page?: number) {
    super()
    this.path = page && page > 1
      ? `account/rma/requests/?page=${page}`
      : 'account/rma/requests/'
  }

  override parseResponse = (data: unknown) =>
    parseRmaOverviewDTO((data as { results: unknown }).results)
}
